import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

declare global {
  interface Window {
    WOW: any;
  }
}

interface TeamMember {
  id: string;
  name: string;
  role: string;
  image: string;
  bio: string;
  facebook?: string;
  twitter?: string;
  linkedin?: string;
  instagram?: string;
}

const TeamDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [member, setMember] = useState<TeamMember | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch team member from API
    if (id) {
      fetch(`http://localhost:5000/api/team/${id}`)
        .then(res => res.json())
        .then(data => {
          setMember(data);
          setLoading(false);
        })
        .catch(error => {
          console.error('Error fetching team member:', error);
          setLoading(false);
        });
    }
  }, [id]);

  useEffect(() => {
    // Initialize data-background attributes
    const elements = document.querySelectorAll('[data-background]');
    elements.forEach((element) => {
      const bg = element.getAttribute('data-background');
      if (bg) {
        (element as HTMLElement).style.backgroundImage = `url(${bg})`;
      }
    });

    // Initialize WOW.js for scroll animations
    if (window.WOW) {
      const wow = new window.WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 0,
        mobile: true,
        live: true
      });
      wow.init();
    }
  }, [member]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <p>Loading team member...</p>
      </div>
    );
  }

  if (!member) {
    return (
      <div className="text-center py-5">
        <h3>Team member not found</h3>
        <Link to="/team" className="btn btn-primary mt-3">Back to Team</Link>
      </div>
    );
  }

  return (
    <>
      {/* Page banner area start here */}
      <section className="banner__inner-page bg-image pt-160 pb-160"
        data-background="/assets/images/banner/banner-inner-page.jpg">
        <div className="container">
          <h2 className="wow fadeInUp" data-wow-delay="00ms" data-wow-duration="1500ms">{member.name}</h2>
          <div className="breadcrumb-list wow fadeInUp" data-wow-delay="200ms" data-wow-duration="1500ms">
            <Link to="/">Home</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i></span>
            <Link to="/team">Our Team</Link>
            <span><i className="fa-regular fa-angles-right mx-2"></i>{member.name}</span>
          </div>
        </div>
      </section>
      {/* Page banner area end here */}

      {/* Team single area start here */}
      <section className="team-single pt-120 pb-120">
        <div className="container">
          <div className="row g-4 align-items-center">
            <div className="col-lg-4 col-md-6">
              <div className="team-single__image">
                <img 
                  src={member.image || '/assets/images/team/team-image1.jpg'} 
                  alt={member.name}
                  style={{ width: '100%', height: '451px', objectFit: 'cover' }}
                />
                <div className="team-info">
                  {member.facebook && (
                    <a href={member.facebook} target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  )}
                  {member.instagram && (
                    <a href={member.instagram} target="_blank" rel="noopener noreferrer" className="active">
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  )}
                  {member.linkedin && (
                    <a href={member.linkedin} target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-linkedin-in"></i>
                    </a>
                  )}
                  {member.twitter && (
                    <a href={member.twitter} target="_blank" rel="noopener noreferrer">
                      <i className="fa-brands fa-twitter"></i>
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-8">
              <div className="team-single__content">
                <div className="title pb-20 mb-20 bor-bottom">
                  <h3>{member.name}</h3>
                  <span className="primary-color mt-1">{member.role}</span>
                </div>
                <div className="team-single__info">
                  <h4 className="pb-2">About {member.name}</h4>
                  <div dangerouslySetInnerHTML={{ __html: member.bio }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Team single area end here */}
    </>
  );
};

export default TeamDetail;
